import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  isEmpty, noop, map,
} from 'lodash';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { normalizeAmount } from '../../../utils/transformer.util';
import {
  Button,
  Input,
  SearchSelect,
  Select
} from '../../../components/base/index';
import { errorAlert } from '../../../utils/alert.util';


const MySwal = withReactContent(Swal);

export default class KodeGuru extends Component {
  constructor(props) {
    super(props);
    this._onChangeFilter = this._onChangeFilter.bind(this);
    this._onSearchContent = this._onSearchContent.bind(this);
    this._onFormChange = this._onFormChange.bind(this);
    this.onClickSubmit = this.onClickSubmit.bind(this);
    this.onClickUpdate = this.onClickUpdate.bind(this);
    this.onClickEdit = this.onClickEdit.bind(this);
    this._setForm = this._setForm.bind(this);
    this._getStaffScheduleOptions = this._getStaffScheduleOptions.bind(this);
    this._getStaffScheduleMoveOptions = this._getStaffScheduleMoveOptions.bind(this);
    this._getPeriodsOptions = this._getPeriodsOptions.bind(this);

    const { location, getLevels, getclassrooms, user,
    } = this.props;
    const { state = {} } = location;
    const { isEdit = false, data } = state;
    const { school_unit, organizations_id } = user;
    this.state = {
      page: 1,
      filters: {},
      showActivationForm: false,
      activationData: null,
      form: {
        value: {
          list: [],
          units_id: school_unit.id,
          organizations_id,
          tipe: data ? data.is_type : 0,
        },
        error: {},
      },
      param: {},
    };
  }

  componentDidMount() {
    const {
      location, getLevels, getclassrooms, user,
    } = this.props;
    const { state = {} } = location;
    const { isEdit = false, data } = state;
    const { school_unit, organizations_id } = user;
    this.injectSwalStyle();
    if (isEdit && data) {
      if (data.is_type == 0 || data.is_type == 2) {
        this._setForm(data);
      }
      if (data.is_type == 1) {
        this._setForm2(data);
      }
    }
    this._onSearchContent();
    this._getStaffScheduleOptions({ units_code: school_unit.unit_code })
    this._getStaffScheduleMoveOptions({ units_code: school_unit.unit_code })
    this._getPeriodsOptions({ units_id: school_unit.id });

  }

  async _getStaffScheduleOptions(filters = {}) {
    const { getStaffScheduleOptions, user } = this.props;
    const { school_unit, user_group } = user;
    const { levels_id } = school_unit;
    const res = await getStaffScheduleOptions(filters);
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        staff: res,
      },
    }));
  }

  async _getPeriodsOptions(filters = {}) {
    const { getPeriodsOptions, user } = this.props;
    const { organizations_id, school_unit } = user;
    const { units_id, levels_id } = school_unit;
    const res = await getPeriodsOptions(filters);
    map(res, (data, idx) => {
      var date = new Date();
      var start_date = new Date(data.attributes.start_date);
      if (date > start_date) {
        // tahun ajaran sekarang
        this.setState((prevState) => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              periods_id: data.value,
            },
          },
          filters: {
            ...prevState.filters,
            periods_id: data.value,
          },
        }));
      }
    });

    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        periods: res,
      },
    }));
  }

  async _getStaffScheduleMoveOptions(filters = {}) {
    const { getStaffScheduleMoveOptions, user } = this.props;
    const { school_unit, user_group } = user;
    const { levels_id } = school_unit;
    const res = await getStaffScheduleMoveOptions(filters);
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        staff_move: res,
      },
    }));
  }

  async _getSchoolUnitsOptions(filters = {}) {
    const { getSchoolUnitsOptions } = this.props;
    const { form } = this.state;
    const { units_id } = form.value;
    const res = await getSchoolUnitsOptions(filters);
    const selectedUnits = res.find(item => item.value == units_id);

    // console.log(units_id)
    this.setState(prevState => ({
      ...prevState,
      form: {
        ...prevState.form,
        value: {
          ...prevState.form.value,
          levels_units: selectedUnits ? selectedUnits.attributes.levels_id : '',
        },
      },
      param: {
        ...prevState.param,
        units: res,
      },
    }));
  }
  // componentDidUpdate(prevProps) {
  //   // const { user } = this.props;
  //   // const { workingUnit } = user;
  //   // const { user: prevUser } = prevProps;
  //   // const { workingUnit: prevWorkingUnit } = prevUser;

  //   // if (!isEqual(workingUnit, prevWorkingUnit)) {
  //   //   this.handleGetData();
  //   // }
  //   if (!isEqual(prevProps, this.props)) {
  //     this._onSearchContent({ page: 1 });
  //   }
  // }
  async onClickDelete(val) {
    const { handleDeleteCodeTeacher, user } = this.props;
    const { form } = this.state;
    const { periods_id } = form.value;
    const { school_unit } = user;
    const res = await handleDeleteCodeTeacher({ ...val, periods_id, units_id: school_unit.id });
    if (res) {
      this._onSearchContent();
    }
  }

  async onClickActivate(val) {
    const { handleActivateCodeTeacher, user } = this.props;
    const { form } = this.state;
    const { periods_id } = form.value;
    const { school_unit } = user;
    const res = await handleActivateCodeTeacher({ ...val, units_id: school_unit.id });
    if (res) {
      this._onSearchContent();
    }
  }

  _onChangeFilter(e) {
    const { target } = e;
    const { value, name } = target;
    const { user } = this.props;
    const { organizations_id, school_unit, user_group } = user;
    if (name === 'user_groups_id') {
      this.setState(prevState => ({
        filters: {
          ...prevState.filters,
          username: '',
        },
      }));
    }
    this.setState(prevState => ({
      ...prevState,
      filters: {
        ...prevState.filters,
        [name]: value,
      },
    }),
      () => {
        if (name === 'perwakilan_id') {
          this.setState(prevState => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                perwakilan_id: value,
                units_id: '',
              },
            },
          }));
          this._getSchoolUnitsOptions({ perwakilan_id: value.value });
          // if(value.value == 'all'){
          // this._onSearchContent();
          // }
        }
        if (name === 'units_id') {
          const param = this.state.param.units;
          const levels_units = param.find(i => i.value == value.value)
            ? param.find(i => i.value == value.value).attributes.levels_id
            : '';

          this.setState(prevState => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                classrooms_id: '',
                levels_id: levels_units,
                units_id: value,
              },
            },
          }));
        }
        this._onSearchContent();
      });
  }

  async _onSearchContent(params = {}) {
    const { filters, param, form } = this.state;
    const savedFilters = JSON.parse(window.localStorage.getItem('param')) || '';
    const prm_usergroups = savedFilters.userGroups;
    const userStudents = prm_usergroups
      ? prm_usergroups.find(e => e.label == 'student')
      : '';

    if (filters.user_groups_id === '') {
      delete filters.user_groups_id;
    }
    if (
      filters.username === ''
      || (!isEmpty(filters.username) && filters.username.value === '')
    ) {
      delete filters.username;
    }

    this.setState(async () => {
      try {
        const { handleListCodeTeacher, user, handleListCodeNonTeacher, handleListDeleteCodeTeacher } = this.props;
        const { school_unit, organizations_id } = user;
        let result = {}
        if (form.value.tipe == 0 || form.value.tipe == 2) {
          result = await handleListCodeTeacher({
            organizations_id,
            units_id: school_unit.id,
            tipe: form.value.tipe,
            filters,
          });
        }
        if (form.value.tipe == 1) {
          result = await handleListCodeNonTeacher({
            organizations_id,
            units_id: school_unit.id,
            filters,
          });
        }
        if (form.value.tipe == 3) {
          result = await handleListDeleteCodeTeacher({
            organizations_id,
            units_id: school_unit.id,
            filters,
          });
        }

        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              list: result,
            },
          },
        }));
      } catch (err) {
        // if (this.isMount) {
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              list: [],
            },
          },
        }));
      }
      // }
    });
  }


  _setIsBlocked(isBlocked) {
    const { form, filters, param } = this.state;
    const { value } = form;
    const { list, classes_id } = value;
    const newList = JSON.parse(JSON.stringify(list));
    newList.forEach((item) => {
      item.is_blocked = isBlocked;
    });

    this.setState(prevState => ({
      ...prevState,
      form: {
        ...prevState.form,
        value: {
          ...prevState.form.value,
          list: newList,
        },
      },
    }));
  }

  injectSwalStyle() {
  const styleId = "swal-custom-inline-style";

  if (document.getElementById(styleId)) return;

  const style = document.createElement("style");
  style.id = styleId;
  style.innerHTML = `
    .swal-popup-custom {
      border-radius: 14px !important;
      padding: 30px !important;
      width: 600px !important;
    }

    .swal-title-custom {
      font-size: 22px !important;
      font-weight: 700 !important;
    }

    .swal2-html-container {
      font-size: 16px !important;
      line-height: 1.7 !important;
      font-weight: 500 !important;
      color: #555 !important;
    }

    .swal2-actions {
      gap: 12px !important;
    }

    .swal-confirm-custom {
      background: #1976d2 !important;
      color: #fff !important;
      border-radius: 8px !important;
      padding: 10px 28px !important;
      font-size: 16px !important;
      font-weight: 600 !important;
    }

    .swal-cancel-custom {
      background: #9e9e9e !important;
      color: #fff !important;
      border-radius: 8px !important;
      padding: 10px 28px !important;
      font-size: 16px !important;
      font-weight: 600 !important;
    }
  `;

  document.head.appendChild(style);
}

  _onFormChange(event) {
    const {
      name, value, dataset, checked, type,
    } = event.target;
    const {
      inputType = 'text',
      inputArray = false,
      arrayPosition = 0,
      fieldName,
    } = dataset;
    const { user } = this.props;
    const { organizations_id } = user;

    this.setState((prevState) => {
      let newList = [];
      let newListError = [];
      let formattedValue = value;

      if (inputType === 'number') {
        formattedValue = normalizeAmount(value);
      }
      if (inputArray) {
        if (type === 'checkbox') {
          formattedValue = checked;
        }
        newList = prevState.form.value[fieldName] || [];
        newListError = prevState.form.error[fieldName] || [];
        newList[arrayPosition][name] = formattedValue;
        if (name === 'code_of_account') {
          newList[arrayPosition].isCredit = value.type;
        }
        if (!isEmpty(newListError[arrayPosition])) {
          newListError[arrayPosition][name] = '';
        }
      }
      return {
        form: {
          value: {
            ...prevState.form.value,
            ...(inputArray
              ? { [fieldName]: newList }
              : { [name]: formattedValue }),
          },
          error: {
            ...prevState.form.error,
            ...(inputArray ? { [fieldName]: newListError } : { [name]: '' }),
          },
        },
      };
    },
      () => {
        // if (name === 'classes_id') {
        //   this._getParamOptionsAcademics( 'classrooms', {classes_id: value, organizations_id });
        // }
        if (name === 'is_blocked' && !inputArray) {
          this._setIsBlocked(value);
        }
        if (name === 'levels_id') {
          this._getClassesOptions({ filters: { levels_id: [value] } });
        }
        if (name === 'classes_id') {
          const param = this.state.param.classes_prm;
          this.setState(prevState => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                // graduate: param.find(i => i.value == value).attributes.graduate,
              },
            },
          }));
        }
        if (name == 'tipe') {
          this._onSearchContent();
        }
      });
  }

  _renderButtons(data) {
    const { user } = this.props;
    const { form } = this.state;

    return (
      <td>
        {(form.value.tipe != 3) ? (
          <div className="table__actions">
            <Button onClick={() => this.onClickEdit(data)} title="Edit" />
            <Button onClick={() => this.openModalMethod(data)} title="Hapus" />
          </div>
        ) :
          <div className="table__actions">
            <Button onClick={() => this.onClickActivate(data)} title="Aktivasi" />
          </div>}
      </td>
    );
  }
  async openModalMethod(data) {

    console.log(data.code)
    // Inject CSS sekali saja
    const styleId = "swal-custom-inline-style";

    if (!document.getElementById(styleId)) {
      const style = document.createElement("style");
      style.id = styleId;
      style.innerHTML = `
  .swal-popup-custom {
    border-radius: 14px !important;
    padding: 25px !important;
  }

  /* override default swal2 button */
  .swal2-styled {
    font-size: 16px !important;
  }

  .swal2-actions {
    gap: 12px !important;   /* jarak antar tombol */
  }

  .swal-confirm-custom {
    background-color: #e53935 !important;
    color: white !important;
    border-radius: 8px !important;
    padding: 10px 20px !important;
    font-size: 16px !important;
    font-weight: 600 !important;
  }

  .swal-cancel-custom {
    background-color: #e0e0e0 !important;
    color: #333 !important;
    border-radius: 8px !important;
    padding: 10px 20px !important;
    font-size: 22px !important;
    font-weight: 500 !important;
  }
`;
      document.head.appendChild(style);
    }

    const result = await MySwal.fire({
      title: <span style={{ fontSize: "16px" }}>Apakah Anda yakin ingin menghapus kode guru {data.code}?</span>,
      // html: (
      //   <div style={{ fontSize: "16px", color: "#555" }}>
      //     Data yang dihapus tidak dapat dikembalikan!
      //   </div>
      // ),
      icon: 'warning',
      width: 400,
      showCancelButton: true,
      cancelButtonText: 'Batal',
      confirmButtonText: 'Ya, hapus',

      buttonsStyling: false, // penting!

      customClass: {
        popup: 'swal-popup-custom',
        confirmButton: 'swal-confirm-custom',
        cancelButton: 'swal-cancel-custom'
      }
    });

    if (result.isConfirmed) {
      this.setState({ isLoading: true });

      try {
        await this.onClickDelete(data);
      } finally {
        this.setState({ isLoading: false });
      }
    }
  }

  onClickAdd() {
    const { history } = this.props;
    history.push('/dashboard/kurikulum/mata-pelajaran/kode-guru', {
      // isEdit: true,
      // data: { units_id: units_id},
    });
  }

  async onClickSubmit() {
    const { history, handleSaveCodeTeacher, user } = this.props;
    const { form } = this.state;
    const { value } = form;
    const { organizations_id } = user;
    let canSaveA = false;

    console.log(value.tipe)
    console.log(canSaveA)
    if (value.tipe == 0 || value.tipe == 2) {
      if (value.code && value.staff) {
        canSaveA = true;
      }
      else {
        canSaveA = false;
      }
    }
    if (value.tipe == 1) {
      if (value.code && value.staff_name) {
        canSaveA = true;
      }
      else {
        canSaveA = false;
      }
    }

    if (canSaveA == false) {
      errorAlert({
        title: 'Terjadi Kesalahan',
        errorMessage: 'Harap lengkapi data form',
      });
      return; // hentikan proses submit
    }
    else {

try {

    await handleSaveCodeTeacher(value);

    history.push('/dashboard/kurikulum/mata-pelajaran/kode-guru');
    history.go(0);

} catch (err) {

    if (err.status === 'edit_deleted') {

        const result = await MySwal.fire({
            title: 'Terjadi Kesalahan',
            html: err.message,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Edit',
            cancelButtonText: 'Batal',
            reverseButtons: true,
            buttonsStyling: false,

            customClass: {
                popup: 'swal-popup-custom',
                title: 'swal-title-custom',
                htmlContainer: 'swal-text-custom',
                confirmButton: 'swal-confirm-custom',
                cancelButton: 'swal-cancel-custom'
            }
        });

        if (result.isConfirmed) {

   this.setState({
    showActivationForm: true,
    form: {
        ...this.state.form,
        value: {
            ...this.state.form.value,
            tipe: '3'
        }
    }
}, () => {

    this._onSearchContent();

    if (err.data.is_type == 1) {
        this._setForm2({
            ...err.data,
            tipe: '3'
        });
    } else {
        this._setForm({
            ...err.data,
            tipe: '3'
        });
    }

});

}

        return;
    }
      // <-- Tambahkan ini untuk error selain edit_deleted
    errorAlert({
        title: 'Terjadi Kesalahan',
        errorMessage: err.message || err.error,
    });

}
    }
  }

  async onClickUpdate() {
    const { history, handleEditCodeTeacher, user } = this.props;
    const { form } = this.state;
    const { value } = form;
    const { organizations_id } = user;
    console.log(value)
    let canSaveA = false;

    if (value.tipe == '0' || value.tipe == '2') {
      if (value.code && value.staff) {
        canSaveA = true;
      }
      else {
        canSaveA = false;
      }
    }
    if (value.tipe == '1' || value.tipe == '3') {
      if (value.code && value.staff_name) {
        canSaveA = true;
      }
      else {
        canSaveA = false;
      }
    }

    if (canSaveA == false) {
      errorAlert({
        title: 'Terjadi Kesalahan',
        errorMessage: 'Harap lengkapi data form',
      });
      return; // hentikan proses submit
    }
    else {
      await handleEditCodeTeacher(value);
      history.push('/dashboard/kurikulum/mata-pelajaran/kode-guru');
      history.go(0);
    }
  }

  async onClickEdit(val) {
    const { history } = this.props;
    history.push('/dashboard/kurikulum/mata-pelajaran/kode-guru', {
      data: val,
      isEdit: true,
    });
    history.go(0);
  }

 async _setForm(data) {
  const { user } = this.props;
  const { school_unit } = user;

  try {
    this.setState({
      form: {
        value: {
          id: data.id,
          code: data.code,
          tipe: data.tipe ? data.tipe : data.is_type,
          ...(data.tipe === '3'
            ? {
                staff_name: data.nip + " - " + data.staff_name
              }
            : {
                staff: {
                  value: data.nip,
                  label: data.nip + " - " + data.nama_lengkap
                }
              }
          ),

          units_id: school_unit.id
        },
        error: {},
      },
    });
  } catch (err) {
    // err action
  }
}
  async _setForm2(data) {
    const { user } = this.props;
    const { organizations_id, school_unit } = user;
    const { form } = this.state;
    try {
      this.setState({
        form: {
          value: {
            id: data.id,
            code: data.code,
            nik: data.nik,
            tipe: data.tipe ? data.tipe : data.is_type,
            staff_name: data.staff_name,
            units_id: school_unit.id
          },
          error: {},
        },
      });
    } catch (err) {
      // err action
    }
  }


  render() {
    const {
      location, getLevels, getclassrooms, user,
    } = this.props;
    const { form, filters, param } = this.state;
    const { state = {} } = location;
    const { isEdit = false, data } = state;
    const { list } = form.value;
    const prm_usergroups = param.userGroups;
    const prm_perwakilan = param.perwakilan_prm ? param.perwakilan_prm : '';
    const prm_units = param.units ? param.units : '';
    const All = [{ value: 'all', label: 'Semua Perwakilan', attributes: {} }];
    const AllUnit = [{ value: 'all', label: 'Semua Unit', attributes: {} }];
    const perwakilan_all = [...All, ...prm_perwakilan];
    const units_all = [...AllUnit, ...prm_units];

    const tipe_staff = [
      { value: '0', label: 'Yayasan' },
      { value: '1', label: 'Non Yayasan' },
      { value: '2', label: 'Moving' },
      { value: '3', label: 'Aktivasi' },
    ];

    const prm_is_block = [
      { value: 0, label: 'Open' },
      { value: 1, label: 'Block' },
    ];

    const dataGet = data || '';
    const userStudents = prm_usergroups
      ? prm_usergroups.find(e => e.label == 'student')
      : '';

    console.log(form.value.tipe)

    return (
      <div className="add-budget">
        <div className="budget__title">
          <h1>Tambah Kode Guru </h1>
          <hr />
        </div>
        <form onClickSubmit={this.onClickSubmit}>
          <div className="kode-matpel__custom-form">
            <Select
              name="tipe"
              label="Pilih Tipe Pegawai"
              onChange={this._onFormChange}
              data={tipe_staff}
              placeholder="Pilihan"
              value={form.value.tipe}
            />
              {(form.value.tipe == 1) &&(
                <div className="kode-matpel__custom-form-row">

                  <Input
                    type="number"
                    name="nik"
                    label="NIK"
                    maxLength={3}
                    onChange={this._onFormChange}
                    value={form.value.nik}
                    error={form.error.nik || ''}
                  />
                </div>
                )}
            {(form.value.tipe != 3 || this.state.showActivationForm) ? (

              <>
                <div className="kode-matpel__custom-form-row">

                  <Input
                    type="text"
                    name="code"
                    label="Kode Guru"
                    maxLength={3}
                    onChange={this._onFormChange}
                    value={form.value.code}
                    error={form.error.code || ''}
                  />

                </div>
              

                {(form.value.tipe == 0 || form.value.tipe == 2) ?

                  <SearchSelect
                    noMargin
                    async={false}
                    name="staff"
                    list={form.value.tipe == 0 ? param.staff : param.staff_move}
                    inputArray
                    onClick={this._onFormChange}
                    disabled={dataGet.id ? true : false}
                    placeholder="Pilih Staff"
                    value={form.value.staff}
                    rightIcon="icon-search"
                    label="Pilih Pegawai"
                  />
                  :
                  <Input
                    type="text"
                    name="staff_name"
                    label="Nama Guru"
                    onChange={this._onFormChange}
                    disabled={form.value.tipe == 3 && form.value.id ? true : false}
                    value={form.value.staff_name}
                    error={form.error.staff_name || ''}
                  />
                }
              </>
            ) : ""
            }

          </div>
          <br></br>
    {(form.value.tipe != 3 || this.state.showActivationForm) && (
  <div className="student-list__header">
    <div className="student-list__button">
      <Button
        type="button"
        title={this.state.showActivationForm ? "Update" : (dataGet.id ? "Update" : "Simpan")}
        onClick={this.state.showActivationForm ? this.onClickUpdate : (dataGet.id ? this.onClickUpdate : this.onClickSubmit)}
      />
    </div>
  </div>
)}
    {/* </div>
  </div>
) : ''} */}
        </form>
        <div className="fund-request__content">
          <table className="table">
            <thead>
              <tr>
                <th>No</th>
                <th>Kode Guru</th>
                {form.value.tipe == 1 ?
                  ''
                  : <th>NIP</th>}
                <th>Nama Guru</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {map(list, (data, idx) => (
                <tr key={`budget_row_${idx}`} style={{ textAlign: "center" }}>
                  <td>{idx + 1}</td>
                  <td>{data.code}</td>
                  {(form.value.tipe == 0 || form.value.tipe == 2 || form.value.tipe == 3) ?
                    <>
                      <td>{data.nip}</td>
                      <td>{data.nama_lengkap}</td>
                    </>
                    :
                    <td>{data.staff_name}</td>
                  }
                  {this._renderButtons(data)}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
KodeGuru.propTypes = {
  handleGetStudent: PropTypes.func,
  handleDeleteStudent: PropTypes.func,
  history: PropTypes.object.isRequired,
};
KodeGuru.defaultProps = {
  handleGetStudent: noop,
  handleDeleteStudent: noop,
};
